// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

interface InputLabelProps {
  children: React.ReactNode;
  required?: boolean;
  htmlFor?: string;
}

export function InputLabel({ children, required = false, htmlFor }: InputLabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className="block text-black text-body-02 font-medium! leading-normal font-sans"
    >
      {children}
      {required && (
        <span className="text-[#E7000B] text-body-02 font-medium! leading-normal font-sans">
          {' '}*
        </span>
      )}
    </label>
  );
}
